import { createRequest } from '../../services/request';

export const GET_ACTOR_SUMMARY_BY_ID = createRequest(
  'ACTORS/GET_ACTOR_SUMMARY_BY_ID',
);
